import { AlertTriangle, Info } from 'lucide-react'
import ReportProblemIcon from '@/assets/icons/report_problem.svg'
import CheckIcon from '@/assets/icons/check.svg'
import CloseIcon from '@/assets/icons/close.svg'
import { Toaster as Sonner } from 'sonner'

function IconBadge({ bg, color, children }: { bg: string; color: string; children: React.ReactNode }) {
  return (
    <div className={`flex items-center justify-center rounded-200 p-2 ${bg}`}>
      <span className={`flex size-6 items-center justify-center ${color}`}>{children}</span>
    </div>
  )
}

export function Toaster() {
  return (
    <Sonner
      position="top-right"
      offset={50}
      closeButton
      toastOptions={{
        unstyled: true,
        classNames: {
          toast: [
            'relative flex w-[320px] items-start gap-3 overflow-hidden rounded-200 p-4',
            'bg-main-surface-lv-02 shadow-[6px_4px_8px_var(--color-main-elevation-lv03)]',
            // bottom accent bar via ::after, colored by data-type
            'after:absolute after:bottom-0 after:left-0 after:h-1 after:w-full after:content-[""]',
            'data-[type=success]:after:bg-main-support-surface-green',
            'data-[type=error]:after:bg-main-support-surface-red',
            'data-[type=warning]:after:bg-main-support-surface-yellow',
            'data-[type=info]:after:bg-main-support-surface-blue',
          ].join(' '),
          icon: 'shrink-0',
          title: 'w-[calc(100%-20px)] truncate text-ui-title-t2 leading-ui-title-t2 font-semibold text-black',
          description: 'text-ui-caption-c1 leading-ui-caption-c1 text-black',
          closeButton:
            'absolute right-1 top-1 flex size-8 cursor-pointer items-center justify-center rounded-200 border-0 bg-transparent text-main-text-lv02 hover:bg-main-surface-lv-02-dim',
        },
      }}
      icons={{
        success: (
          <IconBadge bg="bg-main-support-surface-green" color="text-main-support-on-surface-on-green">
            <CheckIcon className="size-6" />
          </IconBadge>
        ),
        error: (
          <IconBadge bg="bg-main-support-surface-red" color="text-main-support-on-surface-on-rose">
            <ReportProblemIcon className="size-6" />
          </IconBadge>
        ),
        warning: (
          <IconBadge bg="bg-main-support-surface-yellow" color="text-main-support-on-surface-on-yellow">
            <AlertTriangle className="size-5" strokeWidth={2.5} />
          </IconBadge>
        ),
        info: (
          <IconBadge bg="bg-main-support-surface-blue" color="text-main-support-on-surface-on-blue">
            <Info className="size-5" strokeWidth={2.5} />
          </IconBadge>
        ),
        close: <CloseIcon className="size-4" />,
      }}
    />
  )
}
